export const DEFAULT_FORM_SETTINGS = { submitButtonText: '__submit__' };
